import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import Card32ResultBody from '../../../casinoComponents/refResultModal/Card32ResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

// Reference (LastResultsSection, card32 / card32eu / pcard32 / tcard32): win 1..4 → "8".."11"
const WIN_LABEL = { 1: '8', 2: '9', 3: '10', 4: '11' };

/**
 * 32 Cards "Last Result" items in the reference markup (rendered inside
 * CasinoLastResult's .casino-video-last-results): span.resultb per round.
 * Click → full-page .loader-overlay (in .page-content) while the round detail loads,
 * then the reference result modal (RefResultModal + Card32ResultBody).
 * `onTitle` receives the feed's display name (last-results res1.cname) like the reference header.
 */
const ResultCard32 = ({
  data = [],
  gameType = 'card32',
  onTitle,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(gameType);
        if (response?.success && response?.data?.data?.res) {
          setLastResults(response.data.data.res);
          const cname = response.data.data.res1?.cname;
          if (cname && onTitle) onTitle(cname);
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };

    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [gameType, onTitle]);

  const handleResultClick = async (resultItem) => {
    const mid = resultItem?.mid;
    if (!mid) return;
    setDetailResult(null);
    setLoading(true);
    try {
      const response = await getDetailResults(gameType, mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) setDetailResult(t1);
    } catch (error) {
      console.error('Error fetching detail results:', error);
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  const allResults = lastResults.length > 0
    ? lastResults
    : data.map((res) => ({ win: res?.win ?? res, mid: res?.mid ?? null }));

  return (
    <>
      {allResults.map((resultItem, index) => (
        <span
          key={index}
          className="resultb"
          onClick={() => handleResultClick(resultItem)}
        >
          {WIN_LABEL[String(resultItem?.win ?? '')] ?? ''}
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        title={`${detailResult?.ename || '32 Cards'} Result`}
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <Card32ResultBody t1={detailResult} gameType={gameType} />
      </RefResultModal>
    </>
  );
};

export default ResultCard32;
